'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.a7i = null;
  this.a7g = null;
  this.a7f = null;
  this.a7h = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "view");
  this.a7i = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
  var name$1 = (((this.al !== null) && this.al.l()) ? this.al.k() : "edit");
  this.a7g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$1);
  var name$2 = (((this.al !== null) && this.al.l()) ? this.al.k() : "delete");
  this.a7f = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$2);
  var name$3 = (((this.al !== null) && this.al.l()) ? this.al.k() : "schedule");
  this.a7h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$3);
}
export { $c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ as $c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ };
$p = $c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$;
/** @constructor */
function $h_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$() {
}
export { $h_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ as $h_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ };
$h_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$.prototype = $p;
$p.aFP = (function(action) {
  var x = this.a7i;
  if (((x === null) ? (action === null) : x.f(action))) {
    return "View";
  }
  var x$3 = this.a7g;
  if (((x$3 === null) ? (action === null) : x$3.f(action))) {
    return "Edit";
  }
  var x$5 = this.a7f;
  if (((x$5 === null) ? (action === null) : x$5.f(action))) {
    return "Delete";
  }
  var x$7 = this.a7h;
  if (((x$7 === null) ? (action === null) : x$7.f(action))) {
    return "Schedule";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(action);
});
var $d_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$, "mealorama.pages.RecipeListPage$Backend$RecipeAction$", ({
  Lr: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ as $d_Lmealorama_pages_RecipeListPage$Backend$RecipeAction$ };
//# sourceMappingURL=mealorama.pages.-Recipe-List-Page$-Backend$-Recipe-Action$.js.map
